import SiteLayout from "@/components/feature/SiteLayout";
import PageHeader from "@/components/feature/PageHeader";
import JsonLd from "@/components/feature/JsonLd";
import { usePageMeta } from "@/hooks/usePageMeta";
import { results, resultStats } from "@/mocks/results";
import ResultsExplorer from "./components/ResultsExplorer";

const collectionSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "平台处理结果公示",
  description: "按处置类型与月份公示直播争议事件的处理结果，含处置类型、完成时间与处置周期。",
  inLanguage: "zh-CN",
  about: ["平台处理结果", "直播争议事件", "爆料直播"],
};

const itemListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "处理结果公示列表",
  numberOfItems: results.length,
  itemListElement: results.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.title,
    description: item.summary,
  })),
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "首页" },
    { "@type": "ListItem", position: 2, name: "处理结果" },
  ],
};

export default function Results() {
  usePageMeta({
    title: "平台处理结果公示 - 处置类型与完成时间 | 爆料直播",
    description:
      "爆料直播平台处理结果公示区，按警告整改、限制开播、内容下架、退还差额、账号封禁等处置类型与月份筛选查看，公开每起直播争议事件的处置结论、完成时间与处置周期。",
    keywords: "平台处理结果,直播争议事件,爆料直播,直播举报通道",
    path: "/results",
  });

  return (
    <SiteLayout>
      <JsonLd id="ld-results-collection" data={collectionSchema} />
      <JsonLd id="ld-results-list" data={itemListSchema} />
      <JsonLd id="ld-results-breadcrumb" data={breadcrumbSchema} />

      <PageHeader
        eyebrow="处理结果"
        title="平台处理结果公示"
        description="核查结束后，处置结论、完成时间与处置周期都会在这里对外公开。你提交的每一条线索，最终都能在这里找到它的回音。"
        crumbs={[{ label: "首页", path: "/" }, { label: "处理结果" }]}
        meta={
          <dl className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {resultStats.map((stat) => (
              <div key={stat.label} className="bg-background-50 border border-background-200 rounded-lg px-4 py-4">
                <dd className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  {stat.value}
                  <span className="ml-1 text-sm font-medium text-foreground-500">{stat.unit}</span>
                </dd>
                <dt className="mt-1.5 text-xs md:text-sm text-foreground-600">{stat.label}</dt>
              </div>
            ))}
          </dl>
        }
      />

      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <ResultsExplorer />
      </section>
    </SiteLayout>
  );
}